import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import { getFrasesSeleccionAplicacionPlantelThunk } from "../../../store/frasesSeleccionAplicacion/frases-seleccion-aplicacion-plantel/frasesSeleccionAplicacionPlantel.thunks";
import {
  clearFrasesSeleccionAplicacionPlantelError,
  resetFrasesSeleccionAplicacionPlantel,
  setPage,
} from "../../../store/frasesSeleccionAplicacion/frases-seleccion-aplicacion-plantel/frasesSeleccionAplicacionPlantel.reducer";
import Loader from "../../UI/Loader";
import Alert from "../../UI/Alert";
import Pagination from "../../UI/Pagination";
import EmptyState from "../../UI/EmptyState";
import FrasesSeleccionAplicacionHeaderPlantel from "./FrasesSeleccionAplicacionHeaderPlantel";
import FrasesSeleccionAplicacionPlantelTable from "./FrasesSeleccionAplicacionPlantelTable";
import FraseSeleccionAplicacionViewModalPlantel from "./FraseSeleccionAplicacionViewModalPlantel";
import FraseSeleccionAplicacionFormModalPlantel from "./FraseSeleccionAplicacionFormModalPlantel";
import ConfirmToggleFraseSeleccionAplicacionPlantel from "./ConfirmToggleFraseSeleccionAplicacionPlantel";

const FrasesSeleccionAplicacionListLayerPlantel = () => {
  const dispatch = useDispatch();
  const { plantelId } = useParams();
  const { list, loading, error, page, pageSize, search, count } = useSelector(
    (state) => state.frasesSeleccionAplicacionPlantel,
  );

  useEffect(() => {
    if (!plantelId) return;
    dispatch(
      getFrasesSeleccionAplicacionPlantelThunk({ plantelId, page, search }),
    );
  }, [dispatch, plantelId, page, search]);

  useEffect(() => {
    return () => {
      dispatch(resetFrasesSeleccionAplicacionPlantel());
    };
  }, [dispatch]);

  return (
    <div className="card p-0 radius-12">
      <div className="card-body p-24">
        <FrasesSeleccionAplicacionHeaderPlantel />

        {error && (
          <Alert
            message={error}
            variant="error"
            onClose={() =>
              dispatch(clearFrasesSeleccionAplicacionPlantelError())
            }
          />
        )}

        {loading ? (
          <Loader center text="Cargando frases..." delay={200} />
        ) : (
          <>
            {search && (
              <div className="mb-3 d-flex align-items-center gap-2 text-secondary-light">
                <Icon icon="mdi:information-outline" width="18" />
                <span className="text-sm">
                  {count > 0 ? (
                    <>
                      Se {count === 1 ? "encontró" : "encontraron"}{" "}
                      <strong className="text-primary">{count}</strong>{" "}
                      {count === 1 ? "resultado" : "resultados"} para "{search}"
                    </>
                  ) : (
                    <>No se encontraron resultados para "{search}"</>
                  )}
                </span>
              </div>
            )}

            {list.length === 0 ? (
              <EmptyState
                icon={
                  search
                    ? "mdi:magnify-remove-outline"
                    : "mdi:format-quote-close"
                }
                title={
                  search
                    ? "No se encontraron frases"
                    : "No hay frases registradas"
                }
                description={
                  search
                    ? "Intenta con otra búsqueda"
                    : "No hay frases de selección disponibles para este plantel"
                }
              />
            ) : (
              <>
                <FrasesSeleccionAplicacionPlantelTable
                  frases={list}
                  search={search}
                />
                <Pagination
                  page={page}
                  count={count}
                  pageSize={pageSize}
                  onPageChange={(newPage) => dispatch(setPage(newPage))}
                />
              </>
            )}
          </>
        )}
      </div>

      <FraseSeleccionAplicacionViewModalPlantel />
      <FraseSeleccionAplicacionFormModalPlantel />
      <ConfirmToggleFraseSeleccionAplicacionPlantel />
    </div>
  );
};

export default FrasesSeleccionAplicacionListLayerPlantel;
